export const sendVerificationEmail = async (toEmail, otpCode) => {
  const response = await fetch("/api/send-verification-email", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ toEmail, otpCode }),
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(error.error || "Failed to send verification email");
  }

  return true;
};

/**
 * Send the insurance confirmation / fulfilment email after a Plus purchase or
 * an upgrade with insurance. Best-effort: never throws, so a mail hiccup can't
 * break the purchase flow — it logs and returns false instead.
 */
export const sendInsuranceConfirmation = async (payload) => {
  try {
    const response = await fetch("/api/send-insurance-confirmation", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      console.error("Insurance confirmation email failed:", error.error || response.status);
      return false;
    }
    return true;
  } catch (e) {
    console.error("Insurance confirmation email error:", e?.message);
    return false;
  }
};
